const events = {
  SIGNED_IN: "Signed In",
  benefits: {
    category: "Benefit",
    name: "Viewed Benefits",
    properties: {
      title: "Benefits",
      url: "benefits",
    },
  },
  benefitCard: {
    name: "Benefit card clicked",
  },
  createDelivery: {
    type: "track",
    name: "Create a delivery",
  },
  createCustomBenefit: {
    type: "track",
    name: "Create a benefit",
  },
};

export default events;
